
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "marketplace-storefront-public-ui",
  currentProjectVersion: "static-1.13541",
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13541",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1166",
  "client-types": "static-1.512",
  "data-fetching-client": "static-1.10133",
  "foundations-components": "static-1.8777",
  "foundations-components-legacy": "static-1.1802",
  "foundations-theming": "static-1.4984",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.95",
  "head-dlb": "static-1.5330",
  "hs-test-utils": "static-1.8532",
  "hub-http-shared-msw-handlers": "static-1.10933",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11980",
  "I18n": "static-7.1714",
  "jasmine-runner": "static-1.6947",
  "marketplace-discovery-studio-lib": "static-1.936",
  "marketplace-storefront-base": "static-1.13604",
  "quartz": "static-1.7692",
  "react-dlb": "static-1.96",
  "react-rhumb": "static-1.17233",
  "reactive-variable-buffer-atom": "static-1.3346",
  "reporting-testing-lib": "static-1.11351",
  "reselect": "static-3.18",
  "settings-ui-lib": "static-1.13023",
  "SharedI18nStrings": "static-1.190",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7879",
  "ui-addon-i18n": "static-1.11640",
  "ui-addon-react-router-dom": "static-1.10020",
  "unified-auth": "static-1.1291",
  "unified-auth-core-lib": "static-1.1573",
  "usage-tracker": "static-1.7816",
  "usage-tracker-core": "static-1.7666",
  "customer-data-property-utils": "static-1.8546",
  "hub-http": "static-1.6700",
  "integrations-lib": "static-1.17470",
  "marketplace-ui-common": "static-1.21055",
  "marketplace-ui-install": "static-1.1041",
  "property-management-iframe": "static-1.14492",
  "quartz-config": "static-1.1470",
  "quartz-core": "static-1.6911",
  "quartz-routing": "static-1.1122",
  "quick-fetch": "static-1.4242",
  "react": "static-7.204",
  "rpc-client-utils": "static-1.5163",
  "ts-schema": "static-1.4406",
  "ui-universal-auth": "static-1.9777",
  "UIComponents": "static-3.8926",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.523",
  "hs-promise-rejection-tracking": "static-1.6078",
  "PortalIdParser": "static-2.458",
  "raven": "static-3.6411",
  "raven-hubspot": "static-1.6718",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3969",
  "quartz-webpack": "static-1.3916",
  "bend-plugin-quartz-routing": "static-1.770",
  "ai-components-ui-library": "static-1.10057",
  "codemirror": "static-5.108",
  "foundations-assets": "static-1.5382",
  "pulse": "static-1.1143",
  "react-codemirror": "static-1.11136",
  "ui-extensions-preview-lib": "static-1.1014",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5046",
  "floating-ui": "static-1.70",
  "foundations-theming-specialty": "static-1.2700",
  "framer-motion": "static-1.86",
  "hs-story-utils": "static-1.9923",
  "react-aria": "static-1.79",
  "react-create-root-preference": "static-1.110",
  "react-select-plus": "static-1.120",
  "react-utils": "static-2.5673",
  "react-virtualized": "static-2.114",
  "StyleGuideUI": "static-3.520",
  "tanstack-table": "static-1.68",
  "trellis-assets": "static-1.3134",
  "ui-fonts": "static-1.1242",
  "ui-images": "static-2.1281",
  "bend-plugin-foundations-theming": "static-1.3467",
  "foundations-theming-base": "static-1.3969",
  "stylex": "static-1.48",
  "HeadJS": "static-2.828",
  "hs-test-utils-bend-plugin": "static-1.3643",
  "msw": "static-1.105",
  "msw-config": "static-1.33",
  "testing-library": "static-1.167",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4800",
  "ui-addon-video-player": "static-1.9117",
  "ai-rendering-library": "static-1.11435",
  "chirp-fetch": "static-1.2398",
  "connections-embed-lib": "static-1.1785",
  "copilot-toolkit": "static-1.12184",
  "feedback-loader": "static-1.30088",
  "laboratory-lib": "static-3.7640",
  "marketplace-embed": "static-1.23234",
  "marketplace-ui-details": "static-1.10950",
  "marketplace-ui-reviews": "static-1.21010",
  "marketplace-ui-tracking": "static-1.15225",
  "sanitize-text": "static-1.8652",
  "usage-tracker-multi": "static-1.6230",
  "usage-tracker-session-replay": "static-1.5502",
  "beacon-keepalive-queue": "static-1.194",
  "quartz-head": "static-1.1357",
  "web-vitals": "static-1.21",
  "apollo-link-hub-http": "static-2.5082",
  "immer": "static-1.107",
  "immerable": "static-1.4636",
  "highcharts": "static-8.117",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2853",
  "reporting-data": "static-1.69418",
  "cssUtils": "static-1.1116",
  "flux-actions": "static-1.383",
  "react-colorpicker": "static-2.10704",
  "react-dnd-compat": "static-1.5104",
  "redux-observable": "static-1.81",
  "ReduxMessenger": "static-2.10865",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7806",
  "icons": "static-2.707",
  "marketplace-ui-apps-core": "static-1.19587",
  "storybook-react": "static-1.46",
  "trellis-story-utils": "static-1.4993",
  "foundations-components-test-utils": "static-1.6260",
  "quartz-i18n": "static-1.1367",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.788",
  "ads-unified-auth-lib": "static-1.2077",
  "ai-mcp-auth-lib": "static-1.41",
  "custom-vendor-connection-lib": "static-1.341",
  "gemini-settings-lib": "static-1.9815",
  "google-sheets-integration-lib": "static-1.1364",
  "microsoft-drive-auth-lib": "static-1.571",
  "slack-ui-library": "static-1.10893",
  "surveymonkey-integration-lib": "static-1.894",
  "fsm": "static-1.4251",
  "customer-data-objects": "static-1.8203",
  "property-translator": "static-1.5874",
  "hs-locale-management": "static-1.412",
  "frontend-preferences-client": "static-1.8415",
  "hs-promise-utils": "static-1.6086",
  "hubspot-apollo-client": "static-1.5377",
  "integrations-error-boundary-lib": "static-1.14885",
  "integrations-tracking-lib": "static-1.6117",
  "native-integrations-shared-strings": "static-1.8257",
  "sanitize": "static-1.4969",
  "superstore": "static-1.5251",
  "ui-shepherd-react": "static-3.10774",
  "ai-settings-ui-library": "static-1.8622",
  "hub-http-janus": "static-1.912",
  "hubspotter-http": "static-1.4986",
  "immutable-less": "static-1.5146",
  "marketplace-ui-client-types": "static-1.18462",
  "nav-meta": "static-1.30844",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18555",
  "ui-product-approvals-common": "static-1.1633",
  "ai-studio-lib": "static-1.12807",
  "hubspot-prosemirror": "static-1.19314",
  "integrations-reconnect-lib": "static-1.758",
  "ui-addon-iframeable": "static-1.9573",
  "ui-addon-integrations-directory-panel": "static-2.8447",
  "ui-product-approvals": "static-1.29738",
  "ui-tool-access": "static-1.10652",
  "inbound-db-properties-service-client": "static-1.4161",
  "property-management-common": "static-1.6780",
  "opentelemetry-fe-types": "static-1.285",
  "dispatcher": "static-1.150",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.611",
  "module-federation": "static-1.41",
  "opentelemetry-fe": "static-1.660",
  "quartz-auth": "static-1.1367",
  "quartz-test": "static-1.1367",
  "quartz-tracking": "static-1.1071",
  "trellis-components": "static-1.3153",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.573",
  "HubStyle": "static-2.12287",
  "bender-build-tools": "static-1.3604",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23991",
  "ContentUtils": "static-1.69517",
  "customer-data-objects-ui-components": "static-1.13529",
  "sassPrefix": "static-1.381",
  "diff-match-patch": "static-1.7",
  "batch-promise": "static-1.2043",
  "bend-plugin-pulse": "static-1.646",
  "event-emitter": "static-1.1455",
  "fast-json-patch": "static-1.76",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5924",
  "magpie-types": "static-1.5384",
  "stylex-utils": "static-1.180",
  "trellis-theming": "static-1.1509",
  "avatar-components": "static-1.2982",
  "breeze-engine-core": "static-1.1522",
  "breeze-engine-lib": "static-1.2244",
  "breeze-onboarding-components": "static-1.1101",
  "customer-data-filters-ui": "static-1.41429",
  "customer-data-reference-ui-components": "static-1.13668",
  "data-integrations-breeze": "static-1.365",
  "embedded-academy-lib": "static-1.16063",
  "ExportDialog": "static-6.10867",
  "global-styles-ai-lib": "static-1.527",
  "highlight.js": "static-1.92",
  "markdown-it": "static-1.6",
  "marketplace-embed-ba": "static-1.937",
  "mermaid": "static-1.47",
  "reporting-action-components": "static-1.42443",
  "reporting-snowflake": "static-1.58034",
  "reporting-ui-components": "static-2.66687",
  "reporting-visualizations": "static-1.61492",
  "trial-components-library": "static-1.14414",
  "ui-addon-teams": "static-1.22032",
  "upgrade-components-lib": "static-1.750",
  "navigation-components": "static-1.19207",
  "nest": "static-1.730",
  "simple-logging-lib": "static-1.3545",
  "nudge-client-utils": "static-1.3451",
  "fail-safe": "static-1.444",
  "app-governance-lib": "static-1.2775",
  "developer-experience-shared-components": "static-1.11036",
  "purchase-motions-components": "static-1.6657",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10834",
  "usage-tracker-anonymous": "static-1.6233",
  "usage-tracker-public": "static-1.7627",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3785",
  "persist-promise": "static-1.4200",
  "reference-resolvers": "static-1.8678",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4408",
  "hubspot-apollo-cache": "static-1.836",
  "universal-page-editor-lib": "static-1.3507",
  "final-form": "static-1.85",
  "redux-toolkit": "static-1.84",
  "simple-data-table": "static-1.3856",
  "merchandise-lib": "static-1.288",
  "onboarding-scopes": "static-1.6948",
  "ui-addon-draggable": "static-3.5244",
  "content-assistance-lib": "static-1.8448",
  "content-media-capture": "static-1.5827",
  "customer-data-ui-utilities": "static-1.10325",
  "emoji-mart": "static-3.9",
  "file-manager-components": "static-1.24871",
  "growth-payments-core": "static-1.26535",
  "knowledge-content-types": "static-1.8767",
  "PatternValidationJS": "static-1.3376",
  "payment-link-components": "static-1.24495",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20586",
  "ui-addon-emoji-picker": "static-1.10358",
  "ui-business-units-lib": "static-1.9591",
  "video-components-external": "static-1.12479",
  "video-data-lib": "static-1.36137",
  "navigation-messaging": "static-1.8534",
  "collaboration-sidebar": "static-1.59095",
  "trellis-ext-dnd": "static-1.572",
  "crm-component-utils": "static-1.40238",
  "crm-properties-common-lib": "static-1.6391",
  "customer-data-properties": "static-1.53112",
  "external-options-client-types": "static-1.4449",
  "hs-resources": "static-1.678",
  "property-value-citations": "static-1.3726",
  "reference-resolvers-lite": "static-1.8607",
  "opentelemetry-web": "static-1.25",
  "hubspotter-http-shared-msw-handlers": "static-1.10931",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "cms-field-types": "static-1.5304",
  "content-icons-ui": "static-1.2475",
  "atom": "static-1.5566",
  "idb-keyval": "static-1.57",
  "reactive-lib": "static-1.1215",
  "trellis-migration-context": "static-1.76",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1222",
  "breeze-artifacts-sdk": "static-1.1046",
  "getting-started-shared-tasks": "static-1.19596",
  "onboarding-journeys-lib": "static-1.1263",
  "conversations-skeleton-state": "static-1.7613",
  "crm-message-bus": "static-1.44145",
  "customer-data-filters-ui-msw-helpers": "static-1.23864",
  "events-data-lib": "static-1.741",
  "FormUrlGenerator": "static-2.5208",
  "framework-builder-read-service-client": "static-1.4346",
  "multi-account-reference-resolvers": "static-1.1506",
  "onboarding-tours": "static-1.17416",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14801",
  "segments-client-types": "static-1.12231",
  "academy-common-lib": "static-1.15524",
  "dashboard-lib": "static-1.83349",
  "hubspot-prosemirror-plugins": "static-1.19306",
  "share-with-third-party-component-lib": "static-1.9205",
  "ui-asset-management-lib": "static-1.11595",
  "user-context": "static-1.5548",
  "reporting-plugins": "static-1.11023",
  "reporting-reports": "static-1.69094",
  "hubs-service-types": "static-1.1761",
  "purchase-motions-api": "static-1.6660",
  "salesImages": "static-1.752",
  "signup-constants": "static-1.19977",
  "nudge-custom-function-registry": "static-1.3208",
  "nudge-renderer-utils": "static-1.3527",
  "whisper-core-api": "static-1.7670",
  "bend-plugin-fail-safe": "static-1.395",
  "framework-listing-lib": "static-2.29847",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31785",
  "apps-service-types": "static-1.4103",
  "oauth-service-types": "static-1.4630",
  "signup-ui-url-generator": "static-2.8532",
  "onboarding-tours-client": "static-1.5631",
  "one-click-checkout": "static-1.772",
  "platform-infra-nav-components": "static-1.8012",
  "subscription-experience-data-types": "static-1.15464",
  "crm-record-cards-client": "static-1.96",
  "crm-record-cards-service-types": "static-1.3873",
  "framework-data-schema-resolvers": "static-1.7387",
  "location-customization-utils-lib": "static-1.10456",
  "redux-thunk": "static-2.86",
  "react-flip-move": "static-1.85",
  "ui-coaching-tips": "static-1.29603",
  "content-media-composition-data-lib": "static-1.13631",
  "fix-webm-duration": "static-1.36",
  "notification-sounds": "static-1.4923",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3971",
  "seat-types-lib": "static-1.1079",
  "ui-addon-opt": "static-4.8909",
  "commerce-tours-lib": "static-1.6888",
  "growth-onboarding-reliability": "static-1.5577",
  "sales-checkout-service-client": "static-1.4015",
  "data-token-picker": "static-1.17164",
  "FileManagerLib": "static-1.40511",
  "content-media-compositions": "static-2.17638",
  "media-bridge-lib": "static-1.19669",
  "chatspot-widget-iframe": "static-1.23982",
  "collaboration-sidebar-common": "static-1.3892",
  "marketing-platform-lib": "static-1.7400",
  "dnd-kit": "static-1.23",
  "commerce-subscription-lib": "static-1.38087",
  "crm-actions": "static-1.6876",
  "crm-cards-sdk": "static-1.45067",
  "customer-data-properties-shared-msw-handlers": "static-1.10260",
  "customer-data-tracking": "static-1.7367",
  "calling-global-api": "static-1.66245",
  "calling-internal-common": "static-1.31818",
  "calling-lifecycle-internal": "static-1.67627",
  "calling-lifecycle-messages": "static-1.59919",
  "commerce-products-lib": "static-1.10960",
  "conditional-properties-service-client": "static-1.4125",
  "crm-index-visualization-core": "static-1.4783",
  "crm-links": "static-1.6807",
  "crm-pipelines-api-client-types": "static-1.4455",
  "data-agent-utils": "static-1.966",
  "formula-editor": "static-1.15034",
  "google-libphonenumber": "static-1.52",
  "inbounddb-objects-service-types": "static-1.4526",
  "meetings-icalendar-utils-lib": "static-1.1126",
  "multi-currency-client-types": "static-1.4020",
  "object-builder-ui-client": "static-1.50092",
  "pipeline-validation-client-types": "static-1.4295",
  "smart-data-capture-core": "static-1.522",
  "tiered-pricing": "static-1.2314",
  "topics-actions-lib": "static-1.678",
  "trellis-ext-i18n": "static-1.1416",
  "ui-addon-form-validation": "static-1.11351",
  "zustand": "static-1.91",
  "fdsr-migration-layer": "static-1.506",
  "restore-request-side-panel-lib": "static-1.2067",
  "growth-data-modal": "static-1.6162",
  "growth-onboarding-confetti": "static-1.3553",
  "growth-onboarding-next-action-utils": "static-1.3018",
  "onboarding-tours-utils": "static-1.1483",
  "ui-shepherd-tracker": "static-1.8155",
  "crm-index-associations-lib": "static-1.6942",
  "academy-service-client": "static-1.4185",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40370",
  "SafeStorage": "static-1.4890",
  "video-embed": "static-1.36971",
  "wootric-nps": "static-1.7309",
  "redux-actions": "static-3.76",
  "EmailSignatureEditor": "static-1.25280",
  "viral-links-lib": "static-1.7578",
  "nested-table": "static-1.726",
  "timezone-utils": "static-2.5725",
  "getting-started-shared-tasks-store": "static-1.18714",
  "campaign-roi-lib": "static-1.10873",
  "campaigns-utils-lib": "static-1.3744",
  "ui-addon-calendars": "static-2.5861",
  "customer-data-views-management": "static-1.26389",
  "framework-data-table": "static-2.12870",
  "nudge-custom-ui-functions": "static-1.1765",
  "switchboard-lib": "static-1.731",
  "access-check-ui-lib": "static-1.1917",
  "app-users-service-client": "static-1.6114",
  "app-users-service-types": "static-1.5522",
  "mini-checkout-client": "static-1.27867",
  "onboarding-utils": "static-1.5868",
  "permissions-shared-i18n-strings-fe": "static-1.2145",
  "ui-coaching-tips-shared-config": "static-1.29588",
  "checkout-sdk": "static-3.24710",
  "payment-method-components": "static-1.7339",
  "touchless-buying-components": "static-1.6578",
  "upgrade-catalog-service-types": "static-1.3902",
  "edison-service-client-types": "static-1.886",
  "framework-data-schema-quick-fetch": "static-1.7292",
  "growth-onboarding-feedback-components": "static-1.7075",
  "audio-components": "static-1.6599",
  "FileManagerImages": "static-1.38022",
  "video-components": "static-1.14481",
  "js-cookie": "static-1.18",
  "commerce-billing-lib": "static-1.20527",
  "commerce-shared-components-lib": "static-1.19608",
  "commerce-tools-ui-lib": "static-1.11353",
  "crm_data": "static-4.93243",
  "crm-activity-creator-data": "static-1.47779",
  "crm-fe-perf": "static-1.23393",
  "universal-record-utils-lib": "static-1.2402",
  "calling-error-reporting": "static-1.31825",
  "shared-worker-versioning": "static-1.11538",
  "calling-usage-tracker": "static-1.7035",
  "voice-sms-access-library": "static-1.2502",
  "commerce-permissions": "static-1.1280",
  "products-iframe-lib": "static-1.8950",
  "products-ui-components-shared-msw-handlers": "static-1.11315",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11016",
  "sales-views-client-types": "static-1.4752",
  "data-agent-kit": "static-1.953",
  "enrichment-settings-lib": "static-1.270",
  "policy-lib": "static-1.7298",
  "bark-lib": "static-1.17028",
  "browser-prettier": "static-1.11",
  "onboarding-data-sync-lib": "static-1.2865",
  "growth-onboarding-next-action-components": "static-1.3046",
  "user-context-client": "static-1.5004",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.67",
  "urlinator": "static-1.5007",
  "outpost": "static-1.4624",
  "draft-convert": "static-2.86",
  "draft-extend": "static-3.90",
  "draft-js": "static-5.92",
  "draft-plugins": "static-2.22387",
  "sales-email-signature-service-client": "static-1.4343",
  "ts-utils-lib": "static-1.645",
  "copilot-messaging": "static-1.2434",
  "crm-export-dialog": "static-1.6772",
  "crm-index-ui-shimmer": "static-1.3018",
  "crm-view-components": "static-1.1538",
  "react-beautiful-dnd": "static-1.77",
  "customer-data-associations": "static-1.7832",
  "tasks-actions-lib": "static-1.468",
  "InboxConnectUtils": "static-4.15874",
  "emoji-regex": "static-1.7",
  "hub-http-rxjs": "static-1.886",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4481",
  "company-details-components": "static-1.6701",
  "react-performance-metrics-lib": "static-1.1047",
  "pricing-pages-ui-components": "static-1.16652",
  "quote-checkout-service-types": "static-1.3954",
  "social-insights-client-types": "static-1.22960",
  "utility-belt": "static-1.3032",
  "payments-enrollment-embed-lib": "static-1.24252",
  "stripe-embedded-components": "static-1.8276",
  "customer-data-rte": "static-1.33933",
  "cv-backend-services": "static-1.1607",
  "growth-onboarding-empty-states": "static-1.6564",
  "payments-post-enroll-local-storage-lib": "static-1.5600",
  "qrcode-generator": "static-1.82",
  "quotes-client-types": "static-1.39203",
  "crm_universal": "static-1.22753",
  "customer-data-email": "static-1.18670",
  "meetings-rte-lib": "static-1.573",
  "universal-associations-select": "static-1.11591",
  "crm-object-search-query-utilities": "static-1.10491",
  "calling-orchestration-schema": "static-1.37279",
  "react-reducer-toolkit": "static-1.16700",
  "meetings-connect-utils-lib": "static-1.8114",
  "hub-http-contrib": "static-1.3527",
  "ui-addon-sales-email": "static-1.5696",
  "company-details-service-types": "static-1.4438",
  "segments-query-core": "static-1.1925",
  "pricing-pages-api": "static-1.16517",
  "stripe-connect-js": "static-1.85",
  "draft-content-plugins": "static-1.29186",
  "sequences-lib": "static-1.8816",
  "ui-gdpr-components": "static-1.10658",
  "meetings-client-types": "static-1.4084",
  "meetings-core": "static-1.795",
  "sequences-client-types-lib": "static-1.8673"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13541",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1166",
  "client-types": "/client-types/static-1.512",
  "data-fetching-client": "/data-fetching-client/static-1.10133",
  "foundations-components": "/foundations-components/static-1.8777",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1802",
  "foundations-theming": "/foundations-theming/static-1.4984",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.95",
  "head-dlb": "/head-dlb/static-1.5330",
  "hs-test-utils": "/hs-test-utils/static-1.8532",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10933",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11980",
  "I18n": "/I18n/static-7.1714",
  "jasmine-runner": "/jasmine-runner/static-1.6947",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.936",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13604",
  "quartz": "/quartz/static-1.7692",
  "react-dlb": "/react-dlb/static-1.96",
  "react-rhumb": "/react-rhumb/static-1.17233",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3346",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11351",
  "reselect": "/reselect/static-3.18",
  "settings-ui-lib": "/settings-ui-lib/static-1.13023",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7879",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11640",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10020",
  "unified-auth": "/unified-auth/static-1.1291",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1573",
  "usage-tracker": "/usage-tracker/static-1.7816",
  "usage-tracker-core": "/usage-tracker-core/static-1.7666",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8546",
  "hub-http": "/hub-http/static-1.6700",
  "integrations-lib": "/integrations-lib/static-1.17470",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21055",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.1041",
  "property-management-iframe": "/property-management-iframe/static-1.14492",
  "quartz-config": "/quartz-config/static-1.1470",
  "quartz-core": "/quartz-core/static-1.6911",
  "quartz-routing": "/quartz-routing/static-1.1122",
  "quick-fetch": "/quick-fetch/static-1.4242",
  "react": "/react/static-7.204",
  "rpc-client-utils": "/rpc-client-utils/static-1.5163",
  "ts-schema": "/ts-schema/static-1.4406",
  "ui-universal-auth": "/ui-universal-auth/static-1.9777",
  "UIComponents": "/UIComponents/static-3.8926",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.523",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
  "PortalIdParser": "/PortalIdParser/static-2.458",
  "raven": "/raven/static-3.6411",
  "raven-hubspot": "/raven-hubspot/static-1.6718",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3969",
  "quartz-webpack": "/quartz-webpack/static-1.3916",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.770",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10057",
  "codemirror": "/codemirror/static-5.108",
  "foundations-assets": "/foundations-assets/static-1.5382",
  "pulse": "/pulse/static-1.1143",
  "react-codemirror": "/react-codemirror/static-1.11136",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.1014",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5046",
  "floating-ui": "/floating-ui/static-1.70",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2700",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-story-utils": "/hs-story-utils/static-1.9923",
  "react-aria": "/react-aria/static-1.79",
  "react-create-root-preference": "/react-create-root-preference/static-1.110",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-utils": "/react-utils/static-2.5673",
  "react-virtualized": "/react-virtualized/static-2.114",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "tanstack-table": "/tanstack-table/static-1.68",
  "trellis-assets": "/trellis-assets/static-1.3134",
  "ui-fonts": "/ui-fonts/static-1.1242",
  "ui-images": "/ui-images/static-2.1281",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3467",
  "foundations-theming-base": "/foundations-theming-base/static-1.3969",
  "stylex": "/stylex/static-1.48",
  "HeadJS": "/HeadJS/static-2.828",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3643",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.33",
  "testing-library": "/testing-library/static-1.167",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4800",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9117",
  "ai-rendering-library": "/ai-rendering-library/static-1.11435",
  "chirp-fetch": "/chirp-fetch/static-1.2398",
  "connections-embed-lib": "/connections-embed-lib/static-1.1785",
  "copilot-toolkit": "/copilot-toolkit/static-1.12184",
  "feedback-loader": "/feedback-loader/static-1.30088",
  "laboratory-lib": "/laboratory-lib/static-3.7640",
  "marketplace-embed": "/marketplace-embed/static-1.23234",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10950",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.21010",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15225",
  "sanitize-text": "/sanitize-text/static-1.8652",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6230",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5502",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.194",
  "quartz-head": "/quartz-head/static-1.1357",
  "web-vitals": "/web-vitals/static-1.21",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5082",
  "immer": "/immer/static-1.107",
  "immerable": "/immerable/static-1.4636",
  "highcharts": "/highcharts/static-8.117",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2853",
  "reporting-data": "/reporting-data/static-1.69418",
  "cssUtils": "/cssUtils/static-1.1116",
  "flux-actions": "/flux-actions/static-1.383",
  "react-colorpicker": "/react-colorpicker/static-2.10704",
  "react-dnd-compat": "/react-dnd-compat/static-1.5104",
  "redux-observable": "/redux-observable/static-1.81",
  "ReduxMessenger": "/ReduxMessenger/static-2.10865",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7806",
  "icons": "/icons/static-2.707",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19587",
  "storybook-react": "/storybook-react/static-1.46",
  "trellis-story-utils": "/trellis-story-utils/static-1.4993",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6260",
  "quartz-i18n": "/quartz-i18n/static-1.1367",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.788",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.2077",
  "ai-mcp-auth-lib": "/ai-mcp-auth-lib/static-1.41",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.341",
  "gemini-settings-lib": "/gemini-settings-lib/static-1.9815",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1364",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.571",
  "slack-ui-library": "/slack-ui-library/static-1.10893",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.894",
  "fsm": "/fsm/static-1.4251",
  "customer-data-objects": "/customer-data-objects/static-1.8203",
  "property-translator": "/property-translator/static-1.5874",
  "hs-locale-management": "/hs-locale-management/static-1.412",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8415",
  "hs-promise-utils": "/hs-promise-utils/static-1.6086",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5377",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14885",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6117",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8257",
  "sanitize": "/sanitize/static-1.4969",
  "superstore": "/superstore/static-1.5251",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10774",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8622",
  "hub-http-janus": "/hub-http-janus/static-1.912",
  "hubspotter-http": "/hubspotter-http/static-1.4986",
  "immutable-less": "/immutable-less/static-1.5146",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18462",
  "nav-meta": "/nav-meta/static-1.30844",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18555",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1633",
  "ai-studio-lib": "/ai-studio-lib/static-1.12807",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19314",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.758",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9573",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8447",
  "ui-product-approvals": "/ui-product-approvals/static-1.29738",
  "ui-tool-access": "/ui-tool-access/static-1.10652",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4161",
  "property-management-common": "/property-management-common/static-1.6780",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.285",
  "dispatcher": "/dispatcher/static-1.150",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.611",
  "module-federation": "/module-federation/static-1.41",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.660",
  "quartz-auth": "/quartz-auth/static-1.1367",
  "quartz-test": "/quartz-test/static-1.1367",
  "quartz-tracking": "/quartz-tracking/static-1.1071",
  "trellis-components": "/trellis-components/static-1.3153",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.573",
  "HubStyle": "/HubStyle/static-2.12287",
  "bender-build-tools": "/bender-build-tools/static-1.3604",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23991",
  "ContentUtils": "/ContentUtils/static-1.69517",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13529",
  "sassPrefix": "/sassPrefix/static-1.381",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "batch-promise": "/batch-promise/static-1.2043",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.646",
  "event-emitter": "/event-emitter/static-1.1455",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5924",
  "magpie-types": "/magpie-types/static-1.5384",
  "stylex-utils": "/stylex-utils/static-1.180",
  "trellis-theming": "/trellis-theming/static-1.1509",
  "avatar-components": "/avatar-components/static-1.2982",
  "breeze-engine-core": "/breeze-engine-core/static-1.1522",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2244",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.1101",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41429",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13668",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.365",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16063",
  "ExportDialog": "/ExportDialog/static-6.10867",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.527",
  "highlight.js": "/highlight.js/static-1.92",
  "markdown-it": "/markdown-it/static-1.6",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.937",
  "mermaid": "/mermaid/static-1.47",
  "reporting-action-components": "/reporting-action-components/static-1.42443",
  "reporting-snowflake": "/reporting-snowflake/static-1.58034",
  "reporting-ui-components": "/reporting-ui-components/static-2.66687",
  "reporting-visualizations": "/reporting-visualizations/static-1.61492",
  "trial-components-library": "/trial-components-library/static-1.14414",
  "ui-addon-teams": "/ui-addon-teams/static-1.22032",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.750",
  "navigation-components": "/navigation-components/static-1.19207",
  "nest": "/nest/static-1.730",
  "simple-logging-lib": "/simple-logging-lib/static-1.3545",
  "nudge-client-utils": "/nudge-client-utils/static-1.3451",
  "fail-safe": "/fail-safe/static-1.444",
  "app-governance-lib": "/app-governance-lib/static-1.2775",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11036",
  "purchase-motions-components": "/purchase-motions-components/static-1.6657",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10834",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6233",
  "usage-tracker-public": "/usage-tracker-public/static-1.7627",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3785",
  "persist-promise": "/persist-promise/static-1.4200",
  "reference-resolvers": "/reference-resolvers/static-1.8678",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4408",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.836",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3507",
  "final-form": "/final-form/static-1.85",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "simple-data-table": "/simple-data-table/static-1.3856",
  "merchandise-lib": "/merchandise-lib/static-1.288",
  "onboarding-scopes": "/onboarding-scopes/static-1.6948",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5244",
  "content-assistance-lib": "/content-assistance-lib/static-1.8448",
  "content-media-capture": "/content-media-capture/static-1.5827",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10325",
  "emoji-mart": "/emoji-mart/static-3.9",
  "file-manager-components": "/file-manager-components/static-1.24871",
  "growth-payments-core": "/growth-payments-core/static-1.26535",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "PatternValidationJS": "/PatternValidationJS/static-1.3376",
  "payment-link-components": "/payment-link-components/static-1.24495",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20586",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10358",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9591",
  "video-components-external": "/video-components-external/static-1.12479",
  "video-data-lib": "/video-data-lib/static-1.36137",
  "navigation-messaging": "/navigation-messaging/static-1.8534",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.59095",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.572",
  "crm-component-utils": "/crm-component-utils/static-1.40238",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6391",
  "customer-data-properties": "/customer-data-properties/static-1.53112",
  "external-options-client-types": "/external-options-client-types/static-1.4449",
  "hs-resources": "/hs-resources/static-1.678",
  "property-value-citations": "/property-value-citations/static-1.3726",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8607",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10931",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "cms-field-types": "/cms-field-types/static-1.5304",
  "content-icons-ui": "/content-icons-ui/static-1.2475",
  "atom": "/atom/static-1.5566",
  "idb-keyval": "/idb-keyval/static-1.57",
  "reactive-lib": "/reactive-lib/static-1.1215",
  "trellis-migration-context": "/trellis-migration-context/static-1.76",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1222",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1046",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19596",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1263",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7613",
  "crm-message-bus": "/crm-message-bus/static-1.44145",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23864",
  "events-data-lib": "/events-data-lib/static-1.741",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5208",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4346",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1506",
  "onboarding-tours": "/onboarding-tours/static-1.17416",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14801",
  "segments-client-types": "/segments-client-types/static-1.12231",
  "academy-common-lib": "/academy-common-lib/static-1.15524",
  "dashboard-lib": "/dashboard-lib/static-1.83349",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19306",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9205",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11595",
  "user-context": "/user-context/static-1.5548",
  "reporting-plugins": "/reporting-plugins/static-1.11023",
  "reporting-reports": "/reporting-reports/static-1.69094",
  "hubs-service-types": "/hubs-service-types/static-1.1761",
  "purchase-motions-api": "/purchase-motions-api/static-1.6660",
  "salesImages": "/salesImages/static-1.752",
  "signup-constants": "/signup-constants/static-1.19977",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3208",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3527",
  "whisper-core-api": "/whisper-core-api/static-1.7670",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.395",
  "framework-listing-lib": "/framework-listing-lib/static-2.29847",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31785",
  "apps-service-types": "/apps-service-types/static-1.4103",
  "oauth-service-types": "/oauth-service-types/static-1.4630",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8532",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5631",
  "one-click-checkout": "/one-click-checkout/static-1.772",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.8012",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15464",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.96",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3873",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7387",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10456",
  "redux-thunk": "/redux-thunk/static-2.86",
  "react-flip-move": "/react-flip-move/static-1.85",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29603",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13631",
  "fix-webm-duration": "/fix-webm-duration/static-1.36",
  "notification-sounds": "/notification-sounds/static-1.4923",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3971",
  "seat-types-lib": "/seat-types-lib/static-1.1079",
  "ui-addon-opt": "/ui-addon-opt/static-4.8909",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6888",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5577",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4015",
  "data-token-picker": "/data-token-picker/static-1.17164",
  "FileManagerLib": "/FileManagerLib/static-1.40511",
  "content-media-compositions": "/content-media-compositions/static-2.17638",
  "media-bridge-lib": "/media-bridge-lib/static-1.19669",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23982",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3892",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7400",
  "dnd-kit": "/dnd-kit/static-1.23",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38087",
  "crm-actions": "/crm-actions/static-1.6876",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.45067",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10260",
  "customer-data-tracking": "/customer-data-tracking/static-1.7367",
  "calling-global-api": "/calling-global-api/static-1.66245",
  "calling-internal-common": "/calling-internal-common/static-1.31818",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67627",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59919",
  "commerce-products-lib": "/commerce-products-lib/static-1.10960",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4125",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4783",
  "crm-links": "/crm-links/static-1.6807",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4455",
  "data-agent-utils": "/data-agent-utils/static-1.966",
  "formula-editor": "/formula-editor/static-1.15034",
  "google-libphonenumber": "/google-libphonenumber/static-1.52",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4526",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1126",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4020",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50092",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4295",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.522",
  "tiered-pricing": "/tiered-pricing/static-1.2314",
  "topics-actions-lib": "/topics-actions-lib/static-1.678",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1416",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11351",
  "zustand": "/zustand/static-1.91",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.506",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2067",
  "growth-data-modal": "/growth-data-modal/static-1.6162",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3553",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3018",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1483",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8155",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6942",
  "academy-service-client": "/academy-service-client/static-1.4185",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40370",
  "SafeStorage": "/SafeStorage/static-1.4890",
  "video-embed": "/video-embed/static-1.36971",
  "wootric-nps": "/wootric-nps/static-1.7309",
  "redux-actions": "/redux-actions/static-3.76",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25280",
  "viral-links-lib": "/viral-links-lib/static-1.7578",
  "nested-table": "/nested-table/static-1.726",
  "timezone-utils": "/timezone-utils/static-2.5725",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18714",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10873",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3744",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5861",
  "customer-data-views-management": "/customer-data-views-management/static-1.26389",
  "framework-data-table": "/framework-data-table/static-2.12870",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1765",
  "switchboard-lib": "/switchboard-lib/static-1.731",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1917",
  "app-users-service-client": "/app-users-service-client/static-1.6114",
  "app-users-service-types": "/app-users-service-types/static-1.5522",
  "mini-checkout-client": "/mini-checkout-client/static-1.27867",
  "onboarding-utils": "/onboarding-utils/static-1.5868",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2145",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29588",
  "checkout-sdk": "/checkout-sdk/static-3.24710",
  "payment-method-components": "/payment-method-components/static-1.7339",
  "touchless-buying-components": "/touchless-buying-components/static-1.6578",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3902",
  "edison-service-client-types": "/edison-service-client-types/static-1.886",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7292",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7075",
  "audio-components": "/audio-components/static-1.6599",
  "FileManagerImages": "/FileManagerImages/static-1.38022",
  "video-components": "/video-components/static-1.14481",
  "js-cookie": "/js-cookie/static-1.18",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20527",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19608",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11353",
  "crm_data": "/crm_data/static-4.93243",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.47779",
  "crm-fe-perf": "/crm-fe-perf/static-1.23393",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2402",
  "calling-error-reporting": "/calling-error-reporting/static-1.31825",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11538",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7035",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2502",
  "commerce-permissions": "/commerce-permissions/static-1.1280",
  "products-iframe-lib": "/products-iframe-lib/static-1.8950",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11315",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11016",
  "sales-views-client-types": "/sales-views-client-types/static-1.4752",
  "data-agent-kit": "/data-agent-kit/static-1.953",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.270",
  "policy-lib": "/policy-lib/static-1.7298",
  "bark-lib": "/bark-lib/static-1.17028",
  "browser-prettier": "/browser-prettier/static-1.11",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2865",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3046",
  "user-context-client": "/user-context-client/static-1.5004",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.67",
  "urlinator": "/urlinator/static-1.5007",
  "outpost": "/outpost/static-1.4624",
  "draft-convert": "/draft-convert/static-2.86",
  "draft-extend": "/draft-extend/static-3.90",
  "draft-js": "/draft-js/static-5.92",
  "draft-plugins": "/draft-plugins/static-2.22387",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4343",
  "ts-utils-lib": "/ts-utils-lib/static-1.645",
  "copilot-messaging": "/copilot-messaging/static-1.2434",
  "crm-export-dialog": "/crm-export-dialog/static-1.6772",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.3018",
  "crm-view-components": "/crm-view-components/static-1.1538",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.77",
  "customer-data-associations": "/customer-data-associations/static-1.7832",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.468",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15874",
  "emoji-regex": "/emoji-regex/static-1.7",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.886",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4481",
  "company-details-components": "/company-details-components/static-1.6701",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.1047",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16652",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3954",
  "social-insights-client-types": "/social-insights-client-types/static-1.22960",
  "utility-belt": "/utility-belt/static-1.3032",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24252",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8276",
  "customer-data-rte": "/customer-data-rte/static-1.33933",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6564",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5600",
  "qrcode-generator": "/qrcode-generator/static-1.82",
  "quotes-client-types": "/quotes-client-types/static-1.39203",
  "crm_universal": "/crm_universal/static-1.22753",
  "customer-data-email": "/customer-data-email/static-1.18670",
  "meetings-rte-lib": "/meetings-rte-lib/static-1.573",
  "universal-associations-select": "/universal-associations-select/static-1.11591",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10491",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37279",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16700",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8114",
  "hub-http-contrib": "/hub-http-contrib/static-1.3527",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5696",
  "company-details-service-types": "/company-details-service-types/static-1.4438",
  "segments-query-core": "/segments-query-core/static-1.1925",
  "pricing-pages-api": "/pricing-pages-api/static-1.16517",
  "stripe-connect-js": "/stripe-connect-js/static-1.85",
  "draft-content-plugins": "/draft-content-plugins/static-1.29186",
  "sequences-lib": "/sequences-lib/static-1.8816",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10658",
  "meetings-client-types": "/meetings-client-types/static-1.4084",
  "meetings-core": "/meetings-core/static-1.795",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8673"
}
};
